import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

// prettier-ignore
const ContratoCriar = React.lazy(() => import('../pages/contrato-criar'))
const ContratoEditar = React.lazy(() => import('../pages/contrato-editar'))
const ContratoPainel = React.lazy(() => import('../pages/contrato-painel'))
const ContratoRenovacaoCriar = React.lazy(
  () => import('../features/contrato-renovacao/pages/criar'),
)
const ContratoRenovacaoEditar = React.lazy(
  () => import('../features/contrato-renovacao/pages/editar'),
)

export default function Component() {
  return (
    <Routes>
      {/* <Route index element={<Pages.Contracts />} /> */}
      <Route path="novo" element={<ContratoCriar />} />
      <Route path=":contract_id" element={<Outlet />}>
        <Route index element={<ContratoPainel />} />
        <Route path="editar" element={<ContratoEditar />} />
        <Route path="renovacoes/novo" element={<ContratoRenovacaoCriar />} />
        <Route
          path="renovacoes/:renovation_id"
          element={<ContratoRenovacaoEditar />}
        />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
